import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import * as XLSX from 'xlsx';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import { Listoftablesearchbox1, SearchBox, getFilteredData, getFilteredData1 } from "../components/Propertyfile";
import { allowmodifytemplate, Makermodifylisttemplates, deletedataApi, previewrdmdata, updatetextfile3001, updatedataApi } from '../components/ApiProperty';
import { TableTemplateListGapsy, ListofTableFontsize, PaginationComponentForm2, TemplatetablelistTableStructure, TemplatetablelistTableStructure1, TableTemplateList1, MasterModifyTableRDM } from "../components/TableProperty";
import { responseBKP } from "../components/Modalpopup";
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import filterRejectedRecords from '../components/RejectedReason';
import { useSession } from '../components/SessionContext';


const GapsyTablelist = () => {
    const [activeTab, setActiveTab] = useState('manual'); // 'manual' or 'ai'
    const [tableColumns, setTableColumns] = useState([]);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [deleteRowIndex, setDeleteRowIndex] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editingIndexBDm, setEditingIndexBDm] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [notificationType, setNotificationType] = useState('IN');
    const [formStructure, setFormStructure] = useState(null);
    const fileInputRef = useRef(null);
    const [selectedDownloadFormat, setSelectedDownloadFormat] = useState(null); // Store selected format
    const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const location = useLocation();
    const [modalMessage, setModalMessage] = useState('');
    const [notifyType, setNotifyType] = useState('IN'); // Set EOD as default
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [selectedName, setSelectedName] = useState('');
    const [selectedTable, setSelectedTable] = useState(null);
    const [tableNames, setTableNames] = useState([]);
    const [dataModel, setDataModel] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    // const [recordsPerPage] = useState(7); // Set the number of records per page
    const [recordsPerPage, setRecordsPerPage] = useState(5);

    const [currentPage1, setCurrentPage1] = useState(1);
    const [displaySearchValue, setDisplaySearchValue] = useState('');
    const [recordsPerPage1] = useState(5); // Set the number of records per page

    // const [showModal, setShowModal] = useState(false);
    const [modalMessageOne, setModalMessageOne] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    // const prefixes = Object.keys(tableNames);
    const prefixes = Object.keys(tableNames || {});

    // const [showSheetSelectionModal, setShowSheetSelectionModal] = useState(false);
    const [showSheetSelection, setShowSheetSelection] = useState(false);
    const [selectedSheet, setSelectedSheet] = useState(null);
    const [Prefix, setPrefix] = useState("");
    const [selectedFullTableName, setSelectedFullTableName] = useState('');
    const [sheetSelectionModal, setSheetSelectionModal] = useState({
        show: false,
        sheets: [],
        selectedSheets: [],
        workbook: null,
        file: null,
    });
    const [selectedFileName, setSelectedFileName] = useState('');

    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [columnsToDisplay, setColumnsToDisplay] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedDate, setSelectedDate] = useState('');

    const department = sessionStorage.getItem("dept");
    const [rowIdToEdit, setRowIdToEdit] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showConfirmApproveModal, setShowConfirmApproveModal] = useState(false);
    const [rowIdToDelete, setRowIdToDelete] = useState(null);
    const navigate = useNavigate();
    const { sessionId } = useSession();

    // const urlParams = new URLSearchParams(window.location.search);
    // const param = urlParams.get('param');
    // const prefix = param.split('_')[0] || '';
    const urlParams = new URLSearchParams(window.location.search);
    const param = selectedFullTableName;
    const [hasAutoPreviewed, setHasAutoPreviewed] = useState(false);
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('param');
        setParam(paramValue); // This sets it in state
    }, []);

    const formatTableNameForDisplay = (tableName) => {
        if (!tableName) return '';
        return tableName.replace(/_/g, ' ');
    };

    //directly selecting from mdashboard page and selecting dept, tablename and preview
    useEffect(() => {
        // Check for stored values when component mounts
        const storedDept = localStorage.getItem('selectedDept');
        const storedTable = localStorage.getItem('selectedTable');
        const storedDataModel = localStorage.getItem('selectedDataModel');
        if (storedDataModel) {
            setShowDropdown(false);
            setSelectedDownloadFormat(null);
            // Set tab based on DataModel
            const targetTab = storedDataModel === 'DEM' ? 'manual' : 'bulkUpload';
            setActiveTab(targetTab);
            setDataModel(storedDataModel);

            // Set department prefix if available
            if (storedDept) {
                setSelectedPrefix(storedDept);
            }

            // Auto-search and preview if table name exists
            if (storedTable) {
                const [prefix, ...rest] = storedTable.split('_');
                const tableNameWithoutPrefix = rest.join('_');

                // Set search query to trigger filtering
                // setSearchQuery(formatTableNameForDisplay(tableNameWithoutPrefix));
                setSearchQuery(tableNameWithoutPrefix);
                setSelectedFullTableName(storedTable);

                // Simulate table click after a small delay (let data load)
                setTimeout(() => {
                    handleTableClick(storedTable, targetTab);
                }, 500);
            }

            // Clear stored values after use
            localStorage.removeItem('selectedDept');
            localStorage.removeItem('selectedTable');
            localStorage.removeItem('selectedDataModel');
            // Mark that we've auto-previewed
            setHasAutoPreviewed(true);
        }
    }, []);

    let prefix = '';
    if (param) {
        prefix = param.split('_')[0];
    } else {
        console.warn('URL param "param" is missing');
        // Optionally handle the error more gracefully, like:
        // showMessageModal("Missing parameter in URL", "error");
    }

    const [tableName, setTableName] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [paramState, setParam] = useState('');
    const [contacts, setContacts] = useState([]);

    const textFileFormats = ["csv", "xlsx", "txt"];
    const handleFormatSelect = (format) => {
        setSelectedDownloadFormat(format); // Store selected format
        setShowDropdown(false); // Close dropdown after selection
    };

    useEffect(() => {
        fetchData();
    }, [activeTab]);

    const indexOfLastItem = currentPage * recordsPerPage;
    const indexOfFirstItem = indexOfLastItem - recordsPerPage;

    const formatDate = (inputDate) => {
        if (!inputDate) return "";
        const date = new Date(inputDate);
        return date.toISOString().split("T")[0];
    };

    // useEffect(() => {
    //     // Format for display: remove prefix and replace underscores with spaces
    //     const formattedDisplay = searchQuery.includes('_')
    //         ? searchQuery.substring(searchQuery.indexOf('_') + 1).replace(/_/g, ' ')
    //         : searchQuery;

    //     setDisplaySearchValue(formattedDisplay);
    // }, [searchQuery]);

    useEffect(() => {
        const formattedDisplay = searchQuery.replace(/_/g, ' ');
        setDisplaySearchValue(formattedDisplay);
    }, [searchQuery]);


    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const paginate1 = (pageNumber) => {
        setCurrentPage1(pageNumber);
    };
    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };


    const fetchFormStructureAndData = async (tableName, tabKey = activeTab) => {
        try {
            setLoading(true);
            const urlParams = new URLSearchParams(window.location.search);
            const paramValue = urlParams.get('param');
            setParam(paramValue);

            //const formResponse = await fetch(`${PortURL}/demformtemplate/${tableName}.json`);
            const formResponse = await fetch(`/demformtemplate/${tableName}.json`);
            if (!formResponse.ok) throw new Error('Nothing pending for Modification');

            const formStructure = await formResponse.json();
            setFormStructure(formStructure);

            const initialFormData = {};
            if (Array.isArray(formStructure.details)) {
                formStructure.details.forEach(detail => {
                    if (detail.columnActive === "N") {
                        if (detail.columnKey === "" || detail.columnKey?.toLowerCase() === "null" || detail.columnKey?.toLowerCase() === "not null") {
                            switch (detail.columnType.toUpperCase()) {
                                case 'INT':
                                case 'INTEGER':
                                    initialFormData[detail.columnName] = 0;
                                    break;
                                case 'VARCHAR':
                                case 'CHAR':
                                case 'TEXT':
                                    initialFormData[detail.columnName] = 'N';
                                    break;
                                case 'DATE':
                                    initialFormData[detail.columnName] = '1900-01-01';
                                    break;
                                default:
                                    initialFormData[detail.columnName] = null;
                            }
                        }
                    }
                    initialFormData[detail.columnName] = '';
                });
            } else {
                throw new Error('Form structure is not an array.');
            }

            const activeColumns = formStructure.details
                .filter(detail => detail.columnActive !== "N")
                .map(detail => detail.columnName);

            const requiredColumns = ["Rejected_Reason", "Maker_Remarks"];
            requiredColumns.forEach(col => {
                if (!activeColumns.includes(col)) {
                    activeColumns.push(col);
                }
            });

            const dataModel = tabKey === 'manual' ? 'DEM' : 'BDM';

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: {
                    tableName: tableName + "_temp",
                    dataModel: dataModel
                }
            };

            const apiResponse = await axios.post(previewrdmdata, {}, config);

            if (apiResponse.data?.fileName) {
                // const tableResponse = await fetch(`${PortURL}/jsonfiles/${tableName}_temp.json`);
                const tableResponse = await fetch(`/jsonfiles/${tableName}_temp.json`);
                if (!tableResponse.ok) throw new Error('Error fetching table data');

                const rawData = await tableResponse.json();

                let filteredData = dataModel === 'BDM'
                    ? getFilteredData(rawData, activeColumns, search)
                    : getFilteredData1(rawData, activeColumns, search);

                setColumnsToDisplay(activeColumns);
                setTableColumns(activeColumns);
                setTableData(filteredData);
                setTableName(paramValue + "_temp");
                setCurrentPage(1); // reset to first page
            } else {
                throw new Error('No data available for modification');
            }

        } catch (error) {
            console.error("Error:", error.message);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };



    const handleEdit = (rowId) => {
        setRowIdToEdit(rowId);
        setShowEditModal(true);
    };
    const handleEditBDM = (rowId) => {
        setEditingIndexBDm(rowId);
    };


    const handleInputChange = (e, key, index) => {
        const newValue = e.target.value;
        const updatedData = [...tableData];
        updatedData[index][key] = newValue;
        setTableData(updatedData);
    };


    const handleDelete = (rowId) => {
        setRowIdToDelete(rowId);
        setShowConfirmApproveModal(true);
    };

    const handleDelete1 = (rowId) => {
        setRowIdToDelete(rowId);
        setShowConfirmDeleteModal(true);
    };


    useEffect(() => {
        const returningFromEdit = localStorage.getItem('qe-return-from-edit');
        const tableToRefetch = localStorage.getItem('qe-return-param');
        const tab = localStorage.getItem('qe-return-tab');

        if (returningFromEdit === 'true' && tableToRefetch && tab) {
            // Clear the flag so this runs only once
            localStorage.removeItem('qe-return-from-edit');

            // Set tab directly without calling handleTabChange (which resets everything)
            setActiveTab(tab);

            // Restore table-related state (prefix, name, full name)
            const [prefix, ...rest] = tableToRefetch.split('_');
            const name = rest.join('_');

            setSelectedPrefix(prefix);
            setSelectedName(name);
            setSelectedFullTableName(tableToRefetch);
            setPrefix(prefix);

            // Fetch the data
            fetchFormStructureAndData(tableToRefetch, tab);
        }
    }, []);


    const confirmEdit = () => {
        if (rowIdToEdit !== null) {
            localStorage.setItem('qe-return-param', param);           // Table to refetch
            localStorage.setItem('qe-return-tab', activeTab);         // manual/ai tab
            localStorage.setItem('qe-return-from-edit', 'true');      // Flag for returning from edit

            navigate(`/gapsyEditTemplateForm?param=${param}&&file=${param}.json&&rowIndex=${rowIdToEdit}`);
            setShowEditModal(false);
        } else {
            console.error('No row ID to edit.');
        }
    };

    const handleAIUpload = () => {
        navigate(`/gapsyModifyupload`);
    };

    const confirmDelete = async () => {
        try {
            const tablename = tableName.replace('_temp', '');
            const data = { rowId: rowIdToDelete, tableName: param };

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { "tableName": param, "dataModel": "DEM", "rowId": rowIdToDelete }
            };

            // const response = await axios.post('http://172.16.119.156:8081/api/deletedata/dem', data, config);
            const response = await axios.post(deletedataApi, data, config);

            if (response.data && response.data.active_status && response.data.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: response.data.active_status,
                    template_type: response.data.template_type,
                    stage: response.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }
            if (response.data && response.data.message === 'Data Deleted Successfully') {
                setModalMessage(`1 record of <strong>${toTitleCase(selectedName)}</strong> Deleted Successfully`);
                setMessageType('success');
                setShowConfirmApproveModal(false);
                setShowModal(true);
            } else {
                setModalMessage(response.data.message); // Replace with your success message
                setShowConfirmApproveModal(false);
                setMessageType('danger');
                setShowModal(true);
            }


            const updatedTableData = tableData.filter(item => item.rowId !== rowIdToDelete);
            setTableData(updatedTableData);
            setData(updatedTableData);

        } catch (error) {
            console.error('Error deleting data:', error.message);
            setModalMessage('Error deleting data', 'error'); // Show error modal in red
            setMessageType('danger');

        } finally {
            setShowConfirmApproveModal(false);
        }
    };

    const confirmDelete1 = async () => {
        try {
            const tablename = tableName.replace('_temp', '');
            const data = { rowId: rowIdToDelete, tableName: param };

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { "tableName": param, "dataModel": "BDM", "rowId": rowIdToDelete }
            };

            // const response = await axios.post('http://172.16.119.156:8081/api/deletedata/dem', data, config);
            const response = await axios.post(deletedataApi, data, config);

            if (response.data && response.data.active_status && response.data.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: response.data.active_status,
                    template_type: response.data.template_type,
                    stage: response.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }
            if (response.data && response.data.message === 'Data Deleted Successfully') {
                setModalMessage(`1 record of <strong>${toTitleCase(selectedName)}</strong> Deleted Successfully`);
                setMessageType('success');
                setShowConfirmDeleteModal(false);
                setShowModal(true);
            } else {
                setModalMessage(response.data.message); // Replace with your success message
                setShowConfirmDeleteModal(false);
                setShowModal(true);
                setMessageType('danger');
            }


            const updatedTableData = tableData.filter(item => item.rowId !== rowIdToDelete);
            setTableData(updatedTableData);
            setData(updatedTableData);

        } catch (error) {
            console.error('Error deleting data:', error.message);
            setModalMessage('Error deleting data', 'error'); // Show error modal in red
            setMessageType('danger');

        } finally {
            setShowConfirmDeleteModal(false);
        }
    };



    const fetchData = async (tabKey = activeTab) => {
        setvalidErrorRecords([]);
        try {
            const config = {
                headers: { userId: localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: {
                    dept: sessionStorage.getItem("dept"),
                    dataModel: tabKey === 'manual' ? 'DEM' : 'BDM'
                }
            };

            const response = await axios.post(Makermodifylisttemplates, {}, config);
            const message = "Nothing pending for Upload data";

            if (Array.isArray(response.data?.tableList) && response.data.tableList.length > 0) {
                const categorizedTables = {};

                response.data.tableList.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(table);
                });

                setTableNames(categorizedTables);
            } else {
                setTableNames({});
                const dept = sessionStorage.getItem("dept") || "Department not found";
                const updatedMessage = `Nothing pending for Upload data in department: ${dept}`;

                responseBKP(response, setModalMessage, setShowModal, setTableNames, message, updatedMessage);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setTableNames({});
        }
    };




    // Apply final filter on tableData (search + selectedDate)
    const filteredData = tableData.filter(item =>
        (!selectedDate || formatDate(item.date) === selectedDate) &&
        columnsToDisplay.some(column =>
            item[column]?.toString().toLowerCase().includes(searchTerm)
        )
    );


    // Pagination index
    const indexOfLastItem1 = currentPage * recordsPerPage;
    const indexOfFirstItem1 = indexOfLastItem1 - recordsPerPage;

    // Apply pagination if more than 5 records
    const currentItems = filteredData.length > 5
        ? filteredData.slice(indexOfFirstItem1, indexOfLastItem1)
        : filteredData;

    // Total pages for pagination component
    const totalPages2 = Math.ceil(filteredData.length / recordsPerPage);



    const handleTableClick = async (item, tabKey = activeTab) => {
        try {
            // 1. First validate the table name format
            if (typeof item !== 'string' || !item.includes('_')) {
                throw new Error("Invalid table name format");
            }

            // 2. Set the selected table states
            const [prefix, ...restParts] = item.split('_');
            const selectedName = restParts.join('_');

            setSelectedFullTableName(item);
            setPrefix(prefix);
            setSelectedName(selectedName);
            setvalidErrorRecords([]);

            // 3. Check if we're already viewing this table
            if (item === selectedFullTableName) return;

            // 4. Verify modification permissions
            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: {
                    "tableName": item,
                    "modify": "Y",
                    "dataModel": tabKey === 'manual' ? 'DEM' : 'BDM' // Explicitly pass data model
                }
            };

            const response = await axios.post(allowmodifytemplate, {}, config);



            // 5. Only after all checks pass, fetch the data
            await fetchFormStructureAndData(item, tabKey);

        } catch (error) {
            console.error("Table click error:", error);
            setModalMessageOne(error.message || "Failed to load table data");
        }
    };


    useEffect(() => {
        setCurrentPage(1);
    }, [search, selectedDate]);


    const filteredRecords1 = useMemo(() => {
        if (!selectedPrefix || !tableNames || !tableNames[selectedPrefix]) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);



    useEffect(() => {
        setCurrentPage1(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage1(1);
    }, [selectedPrefix]);


    // const sortedRecords1 = useMemo(() => {
    //     return [...filteredRecords1].sort((a, b) => {
    //         const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
    //         const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
    //         return bStarts - aStarts;
    //     });
    // }, [filteredRecords1, searchQuery]);

    const sortedRecords1 = useMemo(() => {
        return [...filteredRecords1].sort((a, b) => {

            const normalizedA = a.toLowerCase().replace(/_/g, ' ');
            const normalizedB = b.toLowerCase().replace(/_/g, ' ');
            const normalizedSearch = searchQuery.toLowerCase().replace(/_/g, ' ');

            const aStarts = normalizedA.startsWith(normalizedSearch);
            const bStarts = normalizedB.startsWith(normalizedSearch);

            return bStarts - aStarts;
        });
    }, [filteredRecords1, searchQuery]);

    const indexOfLastRecord1 = currentPage1 * recordsPerPage1;
    const indexOfFirstRecord1 = indexOfLastRecord1 - recordsPerPage1;
    const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord1, indexOfLastRecord1);

    const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);




    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPrefix]);



    const resetFormAndTableState = () => {
        setColumnsToDisplay([]);
        setTableData([]);
        setData([]);
        setContacts([]);
        setError('');
        setSearch('');
        setSelectedFile(null);
        setModalMessage('');
        setSelectedFileName(null);
        setSelectedSheet('');
        setShowPreview(false);
        setShowDownloadButton(false);
        setShowDropdown(false);
        setShowSheetSelection(false);
        setvalidErrorRecords([]);
        setTableNames({});
        setSelectedName('');
        setSelectedPrefix('');
        setSelectedFullTableName('');
        setPrefix('');
        setEditingIndex(null);
        setEditingIndexBDm(null);
        setDeleteRowIndex(null);
        setFormStructure(null);
        setMessageType('');
    };

    const handleCloseModal = () => {
        setModalMessage('');


        if (messageType === 'warning') {
            // Just close modal, do nothing else
            return;
        }

        setMessageType('');

        if (messageType === 'danger') {
            handleCancel();
            return;
        }

        // For success or default case → full reset
        // resetFormAndTableState();

        if (param && activeTab) {
            fetchFormStructureAndData(param, activeTab);
        }
    };





    const handleTabChange = (tabKey) => {
        const returning = localStorage.getItem('qe-return-from-edit') === 'true';
        if (!returning) {
            resetFormAndTableState(); // only reset if not returning
        }

        // resetFormAndTableState(); // clear form/table-specific state
        setActiveTab(tabKey);
        setSelectedName('');
        setSelectedPrefix('');
        setTableNames({});
        setSelectedDownloadFormat('');

        setSearchTerm('');
        setRecordsPerPage(5); // or your default value
        setCurrentPage(1);

        fetchData(tabKey);
    };


    const handleSearch = (event) => {
        const searchInput = event.target.value.trim().toLowerCase();
        setSearchTerm(searchInput);

        setCurrentPage(1); // Reset pagination to the first page on search
        // setSelectedRowIds([]); // Clear selections when searching

    };

    const handleSearchChange = (e) => {
        const input = e.target.value.trimStart(); // Remove leading spaces
        setSearchQuery(input);

        const pageNumber = parseInt(input, 10);

        // Check if input is a valid page number
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages1) {
            paginate1(pageNumber);
        }
    };

    const handleDashboard = () => {
        navigate('/gapsyMdashboard');
    };

    const showSearchInput = tableData.length > 0 && filterRejectedRecords;

    const handleDeleteClick = (rowIndex) => {
        setDeleteRowIndex(rowIndex); // Set the row index to delete
        setShowConfirmDeleteModal(true); // Show the confirmation modal
    };

    const handleSave = async (rowIndex) => {
        const rowData = tableData[rowIndex];

        if (!formStructure) {
            console.error('Form structure not loaded yet.');
            return;
        }

        const invalidValues = ["", "0", "/N", "//N", "NULL", "\\N", null, undefined];

        // Get NOT NULL and PRIMARY KEY fields
        const mandatoryFields = formStructure.details.filter(detail => detail.columnKey === 'NOT NULL');
        const primaryKeyFields = formStructure.details.filter(detail => detail.columnKey === 'PRIMARY KEY');

        // Forcefully include Maker_Remarks as mandatory (but handle it separately)
        const allMandatoryFields = [...mandatoryFields];
        const makerRemarksField = {
            columnName: "Maker_Remarks",
            columnLabel: "Maker Remarks"
        };

        const missingMandatory = [];
        let isMakerRemarksMissing = false;

        for (const field of allMandatoryFields) {
            const value = rowData[field.columnName];
            if (invalidValues.includes(value?.toString().trim().toUpperCase())) {
                missingMandatory.push(field.columnLabel);
            }
        }

        // Validate Maker_Remarks separately
        const makerRemarksValue = rowData["Maker_Remarks"];
        if (invalidValues.includes(makerRemarksValue?.toString().trim().toUpperCase())) {
            isMakerRemarksMissing = true;
        }

        const missingPrimaryKey = [];
        for (const field of primaryKeyFields) {
            const value = rowData[field.columnName];
            if (invalidValues.includes(value?.toString().trim())) {
                missingPrimaryKey.push(field.columnLabel);
            }
        }

        const totalMissing = [...missingMandatory, ...missingPrimaryKey];
        if (isMakerRemarksMissing) {
            totalMissing.push(makerRemarksField.columnLabel);
        }

        if (totalMissing.length > 0) {
            const formattedFields = totalMissing
                .map(
                    (field, index) =>
                        `<span class="text-warning" style="font-size:14px; font-family:verdana">${field}${index < totalMissing.length - 1 ? ',' : ''}</span>`
                )
                .join(' ');
            const message = `<span style="color: rgba(255, 193, 7, 1); font-size:14px; font-family:verdana;">⚠️ The following fields are missing:</span><br/>${formattedFields}`;
            showMessageModal(message, 'warning');
            return;
        }

        // Valid → Proceed
        handleNotifyPriority(rowIndex);
        setEditingIndexBDm(null);
    };


    const showMessageModal = (message, type) => {
        setModalMessage(message);
        setMessageType(type);
    };


    const handleCancel = async () => {

        try {
            // await fetchData();
            await fetchFormStructureAndData(param, activeTab);
            setEditingIndex(null); // Clear editing mode after fetching data
            setEditingIndexBDm(null);
        } catch (error) {
            console.error("Error during cancel operation:", error);
            setAlertMessage("Failed to fetch data. Please try again.");
            setShowAlert(true);
        }
    };

    const handleNotifyPriority = (rowIndex) => {
        if (notificationType) {
            handleSaveWithNotification(notificationType, rowIndex);
        } else {
            console.error('No notification type selected');
        }
    };

    const handleSaveWithNotification = async (notificationType, rowIndex) => {
        try {
            const rowId = tableData[rowIndex].rowId;
            const tableNameWithJson = `${selectedName}.json`;
            const updatedRow = { ...tableData[rowIndex] };
            const { created_by, created_dt, modified_dt, modified_by, ...dataToUpdate } = updatedRow;

            // ✅ Normalize numeric fields: replace "\N", "", null, undefined → 0
            formStructure.details.forEach(detail => {
                const field = detail.columnName;
                const type = detail.columnType.toUpperCase();

                if (["INT", "INTEGER", "DECIMAL", "NUMERIC", "FLOAT", "DOUBLE"].includes(type)) {
                    const value = dataToUpdate[field];
                    if (value === "" || value === null || value === undefined || value.toString().trim() === "\\N") {
                        dataToUpdate[field] = 0;
                    } else {
                        dataToUpdate[field] = Number(value);
                    }
                }
            });

            // Convert to JSON
            const content = JSON.stringify([dataToUpdate], null, 2);

            // Update text file
            // const responseFile = await axios.post('http://172.16.119.156:3001/update-text-file', { tableNameWithJson, content });
            const responseFile = await axios.post(updatetextfile3001, { tableNameWithJson, content }, {
                headers: {
                    userId: localStorage.getItem('userid'),
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
            });

            console.log('Text file update response:', responseFile.data);

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { "filepath": `/saswork/nas/${tableNameWithJson}`, "Notifications": "IN", "dataModel": "BDM", "rowId": rowId, "tableName": selectedName, "dept": Prefix }
            };

            // Update database
            // const responseDb = await axios.post('http://172.16.119.156:8081/api/updatedata/dem', {}, config);
            const responseDb = await axios.post(updatedataApi, {}, config);
            console.log("responsedata Of bdm", responseDb);


            if (responseDb.data && responseDb.data.active_status && responseDb.data.template_type) {
                localStorage.setItem("active_status", responseDb.data.active_status);
                localStorage.setItem("template_type", responseDb.data.template_type);
                localStorage.setItem("stage", responseDb.data.stage);

                console.log("Stored in localStorage:", {
                    active_status: responseDb.data.active_status,
                    template_type: responseDb.data.template_type,
                    stage: responseDb.data.stage,

                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }


            if (responseDb.data && responseDb.data.message === 'Data Updated Successfully') {
                console.log("first if block!", responseDb.data.message);
                setModalMessage(responseDb.data.message);
                setMessageType('success');
                setShowModal(true);
            } else if (responseDb.data.message) {
                console.log("else if block", responseDb.data.message);
                setModalMessage(responseDb.data.message);
                setMessageType('danger');
                setShowModal(true);

            } else {
                setModalMessage("Failed to create the new file");
                setShowModal(true);
                setMessageType('danger');
            }
        } catch (error) {
            console.error('Error saving data:', error.message);
            setModalMessage('Error saving data');
            setShowModal(true);
            setMessageType('danger');
        }
    };




    const handleRecordsPerPageChange = (e) => {
        setRecordsPerPage(Number(e.target.value)); // Update recordsPerPage state
        setCurrentPage(1); // Reset to the first page
    };

    const normalizeValue = (val) => {
        if (val === "\\N" || val === null || val === undefined) {
            return "";
        }
        return val;
    };


    const handleDownloadClick = () => {
        if (!tableData || tableData.length === 0) {
            // alert("No data to download.");
            return;
        }

        const excludedColumns = ["rowId", "Maker_Remarks", "dataModel", "Rejected_Reason", "created_by", "created_dt", "modified_dt", "modified_by", "active_yn"];

        const filtered = getFilteredData(tableData, columnsToDisplay, search);

        // Remove excluded columns
        const cleanedData = filtered.map(row => {
            const newRow = {};
            Object.keys(row).forEach(key => {
                if (!excludedColumns.includes(key)) {
                    newRow[key] = row[key];
                }
            });
            return newRow;
        });

        const format = selectedDownloadFormat?.toLowerCase();
        if (format === 'csv') {
            const headers = Object.keys(cleanedData[0]);

            const csvRows = cleanedData.map(row => {
                const newRow = headers.map(header => {
                    const val = normalizeValue(row[header]);
                    return val !== "" ? `="${val}"` : "";
                });


                return newRow.join(","); // Comma-separated, no quote wrapping
            });

            const csvContent = [headers.join(","), ...csvRows].join("\n");

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            triggerDownload(blob, `${selectedName || "table"}.csv`);
        }

        else if (format === 'json') {
            const blob = new Blob([JSON.stringify(cleanedData, null, 2)], { type: "application/json" });
            triggerDownload(blob, `${selectedName || "table"}.json`);

        } else if (format === 'xlsx') {
            // const worksheet = XLSX.utils.json_to_sheet(cleanedData);
            const processedData = cleanedData.map(row => {
                const newRow = {};
                for (const key in row) {
                    if (Object.hasOwn(row, key)) {
                        const val = row[key];
                        // Convert large numbers and decimals to string
                        // newRow[key] = typeof val === 'number' || /^[0-9.]+$/.test(val) ? `${val}` : val;
                        const normalized = normalizeValue(val);

                        newRow[key] =
                            normalized === ""
                                ? ""
                                : typeof normalized === "number" || /^[0-9.]+$/.test(normalized)
                                    ? `${normalized}`
                                    : normalized;

                    }
                }
                return newRow;
            });

            const worksheet = XLSX.utils.json_to_sheet(processedData);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            triggerDownload(blob, `${selectedName || "table"}.xlsx`);

        } else if (format === 'txt') {
            const headers = Object.keys(cleanedData[0]);
            const txtRows = cleanedData.map(row =>
                headers.map(header => {
                    const val = row[header];
                    // return typeof val === 'number' ? val.toString() : (val ?? '');
                    const normalized = normalizeValue(val);
                    return normalized;

                }).join("\t") // Use tab-delimited or use "|" if preferred
            );

            const txtContent = [headers.join("\t"), ...txtRows].join("\n");

            const blob = new Blob([txtContent], { type: "text/plain;charset=utf-8;" });
            triggerDownload(blob, `${selectedName || "table"}.txt`);
        }

        else {
            // alert("Unsupported format selected.");
        }
    };

    // Helper to trigger download
    const triggerDownload = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    };


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-pencil-square me-2"></i>Modify Rejected Data
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            {/* <div className="gapsybdmupload-page"> */}
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className={`row m-2 rounded-1 ${styles.cardBorder}`}>
                            <div className={`col-lg-12 col-md-12`}>
                                {/* Tabs */}
                                <div className={tabStyles.tabContainer}>
                                    <div
                                        className={`${tabStyles.tab} ${activeTab === 'manual' ? tabStyles.activeTab : ''}`}
                                        onClick={() => handleTabChange('manual')}
                                    >
                                        <i className="bi bi-pencil-square me-1"></i> Quick Entry
                                    </div>
                                    <div
                                        className={`${tabStyles.tab} ${activeTab === 'bulkUpload' ? tabStyles.activeTab : ''}`}
                                        onClick={() => handleTabChange('bulkUpload')}
                                    >
                                        <i className="bi bi-pencil-square me-1"></i> Bulk Upload
                                    </div>
                                </div>

                                {activeTab === 'manual' && (
                                    // <div className={`row m-2`}>
                                    //     <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>
                                    //         Modify Rejected Data
                                    //         {selectedName ? `: ${selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}` : ''}
                                    //     </h6>
                                    <div className={`row m-2`}>
                                        <div className={`d-flex justify-content-between align-items-center pb-1 mb-2 ${styles.borderBottom}`}>
                                            {/* Left: Heading */}
                                            <h6 className={`mb-0`}>
                                                Modify Rejected Data
                                                {selectedName ? `: ${selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}` : ''}
                                            </h6>

                                            {/* Right: Search + Records Per Page */}
                                            {showSearchInput && (
                                                <div className="d-flex align-items-center ms-3">
                                                    {/* Records Per Page Selector */}
                                                    <div className="me-3">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={recordsPerPage}
                                                            onChange={handleRecordsPerPageChange}
                                                            style={{ width: '70px' }}
                                                        >
                                                            <option value="5">5</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select>
                                                    </div>

                                                    {/* Search Box */}
                                                    <div>
                                                        <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
                                                    </div>
                                                </div>
                                            )}

                                        </div>


                                        <div className={`col-lg-4 col-md-12 ${styles.verticalDivider}`}>
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <div>
                                                    <DepartmentDropdown
                                                        selectedPrefix={selectedPrefix}
                                                        setSelectedPrefix={setSelectedPrefix}
                                                        prefixes={prefixes}
                                                    />
                                                </div>

                                                {/* Search Bar */}
                                                <div className="flex-grow-1">
                                                    <Listoftablesearchbox1
                                                        // searchQuery={searchQuery}
                                                        searchQuery={displaySearchValue}
                                                        onSearchChange={handleSearchChange}
                                                    />
                                                </div>
                                            </div>

                                            <TableTemplateListGapsy
                                                currentRecords={currentRecords1}
                                                ListofTableFontsize={ListofTableFontsize}
                                                handleTableClick={handleTableClick}
                                                currentPage={currentPage1}  // Pass currentPage
                                                recordsPerPage={recordsPerPage1}  // Pass recordsPerPage
                                            />
                                            {/* </div> */}

                                            {/* </div> */}
                                            {sortedRecords1.length > recordsPerPage1 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage1}
                                                    totalPages={totalPages1}
                                                    paginate={paginate1}
                                                    recordsPerPage={recordsPerPage1}
                                                    tableNames={sortedRecords1} // ← pass sorted list
                                                />
                                            )}

                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            <TemplatetablelistTableStructure
                                                loading={loading}
                                                error={error}
                                                currentItems={currentItems}
                                                columnsToDisplay={columnsToDisplay}
                                                handleEdit={handleEdit}
                                                handleDelete={handleDelete}
                                            // handlecounter={handlecounter}
                                            />

                                            {filteredData.length > 5 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage}
                                                    totalPages={totalPages2}
                                                    paginate={paginate}
                                                    recordsPerPage={recordsPerPage}
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                                {activeTab === 'bulkUpload' && (
                                    <div className={`row m-2`}>
                                        {/* <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify Rejected Data {selectedName ? `: ${selectedName}` : ''}</h6> */}
                                        <div className={`d-flex justify-content-between align-items-center pb-1 mb-2 ${styles.borderBottom}`}>
                                            <h6 className="mb-0">
                                                Modify Rejected Data
                                                {selectedName ? `: ${selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}` : ''}
                                            </h6>
                                            {showSearchInput && (
                                                <div className="d-flex align-items-center ms-auto">
                                                    {/* Records Per Page Selector */}
                                                    <div className="me-3">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={recordsPerPage}
                                                            onChange={handleRecordsPerPageChange}
                                                            style={{ width: '70px' }}
                                                        >
                                                            <option value="5">5</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select>
                                                    </div>

                                                    {/* Search Box */}
                                                    <div>
                                                        <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-flex gap-2 align-items-center">
                                                {/* Dropdown Download Button */}
                                                <div
                                                    className="custom-dropdown position-relative"
                                                    onMouseEnter={() => selectedName && setShowDropdown(true)}
                                                    onMouseLeave={() => selectedName && setShowDropdown(false)}
                                                >
                                                    <button
                                                        className="btn btn-primary btn-sm btn-download"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Click to Download the data in Bulk"
                                                        onClick={handleDownloadClick}
                                                        disabled={!selectedName}
                                                    >
                                                        {selectedDownloadFormat ? `Download (.${selectedDownloadFormat})` : "Download"}
                                                    </button>

                                                    {showDropdown && selectedName && (
                                                        <ul className="dropdown-menu show text-start">
                                                            {textFileFormats.map((format) => (
                                                                <li key={format}>
                                                                    <button
                                                                        className="custom-dropdown-item"
                                                                        onClick={() => handleFormatSelect(format)}
                                                                    >
                                                                        .{format}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>



                                                <button className="btn btn-outline-secondary btn-sm" onClick={handleAIUpload}>
                                                    Modify Upload
                                                </button>
                                            </div>
                                        </div>


                                        <div className={`col-lg-4 col-md-12 ${styles.verticalDivider}`}>
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <div>
                                                    <DepartmentDropdown
                                                        selectedPrefix={selectedPrefix}
                                                        setSelectedPrefix={setSelectedPrefix}
                                                        prefixes={prefixes}
                                                    />
                                                </div>

                                                {/* Search Bar */}
                                                <div className="flex-grow-1">
                                                    <Listoftablesearchbox1
                                                        // searchQuery={searchQuery}
                                                        searchQuery={displaySearchValue}
                                                        onSearchChange={handleSearchChange}
                                                    />
                                                </div>
                                            </div>

                                            <TableTemplateListGapsy
                                                currentRecords={currentRecords1}
                                                ListofTableFontsize={ListofTableFontsize}
                                                handleTableClick={handleTableClick}
                                                currentPage={currentPage1}  // Pass currentPage
                                                recordsPerPage={recordsPerPage1}  // Pass recordsPerPage
                                            />
                                            {/* </div> */}

                                            {/* </div> */}
                                            {sortedRecords1.length > recordsPerPage1 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage1}
                                                    totalPages={totalPages1}
                                                    paginate={paginate1}
                                                    recordsPerPage={recordsPerPage1}
                                                    tableNames={sortedRecords1} // ← pass sorted list
                                                />
                                            )}

                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            <TemplatetablelistTableStructure1
                                                loading={loading}
                                                error={error}
                                                currentItems={currentItems}
                                                columnsToDisplay={columnsToDisplay}
                                                columnDetails={formStructure?.details || []}
                                                handleEditBDM={handleEditBDM}
                                                handleEdit={handleEdit}
                                                handleDelete={handleDelete1}
                                                handleInputChange={handleInputChange}
                                                handleSave={handleSave}
                                                handleCancel={handleCancel}
                                                handleDeleteClick={handleDeleteClick}
                                                editingIndexBDm={editingIndexBDm}
                                                totalPages={totalPages1}
                                                currentPage={currentPage}
                                                paginate={paginate}
                                            // handlecounter={handlecounter}
                                            />

                                            {filteredData.length > 5 && (
                                                <PaginationComponentForm2
                                                    currentPage={currentPage}
                                                    totalPages={totalPages2}
                                                    paginate={paginate}
                                                    recordsPerPage={recordsPerPage}
                                                />
                                            )}


                                        </div>
                                    </div>
                                )}
                            </div>

                            <Modal show={modalMessage} onHide={() => setModalMessage('')} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107' }}></span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                fontSize: '14px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                            dangerouslySetInnerHTML={{ __html: modalMessage }}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseModal}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>

                            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                <Modal.Header style={{
                                    backgroundColor: '#366872',
                                    color: 'white',
                                    padding: '0.5rem 1rem'
                                }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Edit</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    <p>Are you sure you want to Edit this record?</p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant='secondary' onClick={() => setShowEditModal(false)}>Cancel</Button>
                                    <Button variant="primary"
                                        onClick={confirmEdit}>Confirm</Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showConfirmApproveModal} onHide={() => setShowConfirmApproveModal(false)} backdrop="static" keyboard={false}
                                style={{ marginTop: '12vh' }}>
                                <Modal.Header style={{
                                    backgroundColor: '#366872',
                                    color: 'white',
                                    padding: '0.5rem 1rem'
                                }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                >
                                    <p>Are you sure you want to Delete this record?</p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary" onClick={() => setShowConfirmApproveModal(false)}>Cancel</Button>
                                    <Button variant="primary" onClick={() => confirmDelete()}>Confirm</Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showConfirmDeleteModal} onHide={() => setShowConfirmDeleteModal(false)} keyboard={false}
                                style={{ marginTop: '12vh' }}>
                                <Modal.Header style={{
                                    backgroundColor: '#366872',
                                    color: 'white',
                                    padding: '0.5rem 1rem'
                                }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                >
                                    <p>Are you sure you want to Delete this record?</p></Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>

                                    <Button variant="secondary" onClick={() => setShowConfirmDeleteModal(false)}>Cancel</Button>

                                    <Button variant="primary" onClick={() => confirmDelete1()}>Confirm</Button>
                                </Modal.Footer>
                            </Modal>
                        </div>

                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default GapsyTablelist;
